import { call, put, select, takeEvery } from 'redux-saga/effects';
import { getJSON } from '../../shared/util-fetch';

export function* getAutoLoginLink() {
    const { logged_in } = yield select(state => state.user);

    let autologin = {
        m: null,
        mauto: null,
    };

    if (logged_in) {
        autologin = yield call(getJSON, '/api/member/get-autologin');
    }

    yield put({
        type: 'autologin-link:update',
        payload: autologin,
    });
}

export function* root() {
    yield takeEvery('autologin-link:get', getAutoLoginLink);
}
